import { UniversalSurfaceRenderer } from '../../../../platform/UniversalSurfaceRenderer';
import { Matrix } from '../../../../platform/geom/Matrix';
import { Point } from '../../../../platform/geom/Point';
import { Particle } from './Particle';

const star = new Path2D(
    `M11.5679 0.741794C11.7608 0.41066 12.2392 0.410661 12.4321 0.741794L15.7685 6.4701C15.8391 6.5914 
    15.9575 6.67741 16.0947 6.70712L22.5737 8.11011C22.9482 8.19122 23.096 8.64618 22.8407 8.93193L18.4238 
    13.8752C18.3302 13.9799 18.285 14.1191 18.2992 14.2587L18.9669 20.8541C19.0056 21.2354 18.6185 21.5166 
    18.2679 21.362L12.2016 18.6888C12.0732 18.6322 11.9268 18.6322 11.7984 18.6888L5.73213 21.362C5.38146 
    21.5166 4.99445 21.2354 5.03305 20.8541L5.70083 14.2587C5.71497 14.1191 5.66975 13.9799 5.57622 
    13.8752L1.1593 8.93193C0.90397 8.64618 1.0518 8.19122 1.42632 8.11011L7.90527 6.70712C8.04247 
    6.67741 8.16086 6.5914 8.23151 6.4701L11.5679 0.741794Z`
);

export class StarParticle implements Particle {

    private lifetime = .5;
    private age = 0;

    public rot = 0;

    constructor(
        public pos: Point,
        public vel: Point,
        public spin: number,
    ) {
    }

    public update(dt: number): boolean {
        this.age += dt;

        this.rot = this.spin * this.age;
        this.pos = this.pos.add(this.vel.multiply(300 * dt));

        return this.age < this.lifetime;
    }

    public paint(gfx: UniversalSurfaceRenderer, mvm: Matrix): void {
        gfx.setTransform(
            Matrix.identity
                .multiply(mvm)
                .translate(this.pos)
                .rotate(this.rot)
                .translate(-12, -12)
        );
        gfx.globalAlpha = 1 - this.age / this.lifetime;
        gfx.fillStyle = 'gold';
        gfx.fill(new Path2D(star));
    }
}
